import GroupDependency from './GroupDependency';

export default class FulfilledDependency {
	times: number;
	dependsOn: string;
	dependency: GroupDependency;
}
